<template lang="html">
  <div>
    <v-row
      class="mb-4" 
      align="center" 
    >
      <h6 class="pl-3 title font-weight-medium">
        {{ text.header }}
      </h6>
    </v-row>
    <div v-if="!summary">
      <p>
        {{ text.description }}
      </p>

      <ul>
        <li 
          v-for="(effect,index) in text.effects" 
          :key="index"
        >
          {{ effect }}
        </li>
      </ul>

      <v-form 
        ref="form"
      >
        <v-container>
          <v-row 
            v-for="(selectedBranch,index) in toUpdateList" 
            :key="index"
          >
            <v-col 
              cols="12" 
              md="12"
            >
              <v-autocomplete
                v-if="!toUpdateList[index].reportToVessel"
                v-model="toUpdateList[index].branch_person_in_charge_uid"
                v-validate="'required'"
                :items="filteredUsers"
                :error-messages="errors.collect('incharge'+index)"
                :label="selectedBranch.branch_name + ' new BIC'"
                :disabled="selectedBranch.confirmed"
                :data-vv-name="'incharge'+index"
                class="autocomplete-zindex"
                data-vv-as="BIC"
                item-text="name"
                item-value="user_uid"
              />

              <p v-show="toUpdateList[index].reportToVessel">
                {{ selectedBranch.branch_name }}
              </p>
            </v-col>

            <v-col 
              cols="12" 
            >
              <v-checkbox
                v-model="toUpdateList[index].reportToVessel"
                :disabled="selectedBranch.confirmed"
                class="mt-0 pt-0"
                label="Temporary no BIC"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>

    <div 
      v-else 
    >
      <p>
        {{ actionSummary.description }}
      </p>

      <div 
        v-for="(branch,i) in actionSummary.branches" 
        :key="i"
      >
        <p>
          {{ branch.branch_name }}
        </p>

        <ul>
          <li 
            v-for="(effect,index) in branch.effects" 
            :key="index"
          >
            <span class="font-weight-medium">{{ effect }}</span>
          </li>
        </ul>
        <br>
      </div>
    </div>
      
    <v-card-actions>
      <v-spacer />

      <v-btn
        v-if="toUpdateList.length>1 && !summary"
        :disabled="progressing"
        text
        @click="undoPrevious"
      >
        Undo
      </v-btn>

      <v-btn
        v-if="!summary"
        :loading="progressing"
        class="mx-2 font-weight-light"
        color="success"          
        @click="showSummary"
      >
        Save
      </v-btn>

      <v-btn
        v-if="summary"
        :disabled="progressing"
        text
        @click="summary = false;undoPrevious()"
      >
        Cancel
      </v-btn>

      <v-btn
        v-if="summary && toUpdateList.length<2"
        disabled
        :loading="progressing"
        class="mx-2 font-weight-light"
        color="success"          
        @click="submitForm"
      >
        Not BIC Transfer, cannot proceed.
      </v-btn>

      <v-btn
        v-if="summary && toUpdateList.length>=2"
        :loading="progressing"
        class="mx-2 font-weight-light"
        color="success"          
        @click="submitForm"
      >
        Confirm Changes
      </v-btn>
    </v-card-actions>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    $_veeValidate: {
      validator: 'new', // give me my own validator scope.
    },
    props: {
      users: {
        type: Array,
        default: () => {
          return []
        },
      },
    },
    data () {
      return {
        text: {
          header: 'BIC Transfer',
          description: 'This form is to transfer a BIC from one branch to another. What this form will do is as follows:',
          effects: [
            'Selected CRO will be set as branch\'s new BIC',
            'Remaining CRO will report to new BIC',
            'If new BIC is previously a BIC from another branch, you will be prompted to select a new BIC for that branch',
            'Action must consist at least of two branches. Anything less, please use Internal/External Transfer',
          ],
        },
        progressing: false,
        summary: false,
        branchList: [],
        toUpdateList: [],
      }
    },
    computed: {
      filteredUsers () {
        return this.users.filter((user) => {
          return user.vessel === null
        })
      },
      textForSelect () {
        return (this.branchList.length === 0 
          ? this.branch.branch_name 
          : this.branchList[this.branchList.length - 1].branch_name) + '\'s New BIC'
      },
      actionSummary () {
        let summary = {
          description: 'This form is to transfer a BIC from one branch to another. Confirm your actions:',
          branches: [],
        }

        this.toUpdateList.forEach((branchToUpdate, index) => {
          let newBic = this.findUserUsingUid(branchToUpdate.branch_person_in_charge_uid)

          let oldBic = index === 0 
            ? this.findUserUsingUid(this.branch.branch_person_in_charge_uid) 
            : this.findUserUsingUid(this.branchList[index - 1].branch_person_in_charge_uid)
        
          if (branchToUpdate.reportToVessel === true) {
            let branchSummary = {
              branch_name: index === 0 ? this.branch.branch_name : this.branchList[index - 1].branch_name,
              effects: [
                'Remaining CRO will report to vessel',
              ],
            }
            summary.branches.push(branchSummary)
          } else {
            let branchSummary = {
              branch_name: index === 0 ? this.branch.branch_name : this.branchList[index - 1].branch_name,
              oldBic: oldBic.name,
              newBic: newBic.name,
              effects: [
                newBic.name + ' will be set as branch\'s new BIC',
                'Remaining CRO will report to ' + newBic.name,
              ],
            }

            if (index > 0) {
              branchSummary.effects.shift()
            }
            summary.branches.push(branchSummary)
          }
        })

        return summary
      },
      ...mapGetters({
        branch: 'branch/currentBranch',
      }),
    },
    watch: {
      branch: {
        immediate: true,
        handler (val) {
          if (val) {
            this.toUpdateList = [
              {
                branch_uid: this.branch.branch_uid,
                branch_person_in_charge_uid: '',
                branch_name: this.branch.branch_name,
                confirmed: false,
                reportToVessel: false,
              },
            ]
          }
        },
      },
    },
    mounted () {
   
    },
    methods: {
      undoPrevious () {
        if (this.toUpdateList[this.toUpdateList.length - 1].confirmed === false) {
          this.branchList.pop()
          this.toUpdateList.pop()
        } 
        this.toUpdateList[this.toUpdateList.length - 1].confirmed = false
      },
      findUserUsingUid (uid) {
        return this.users.find((user) => {
          return user.user_uid === uid
        })
      },
      addIntoUpdateList () {
        this.toUpdateList.push({
          branch_name: this.branchList[this.branchList.length - 1].branch_name,
          branch_uid: this.branchList[this.branchList.length - 1].branch_uid,
          branch_person_in_charge_uid: '',
          confirmed: false,
          reportToVessel: false,
        })
      },
      checkIfBic (userUid) {
        this.toUpdateList[this.toUpdateList.length - 1].confirmed = true

        if (this.toUpdateList[this.toUpdateList.length - 1].reportToVessel === true) {
          this.summary = true
          if (this.toUpdateList.length === 1) {
            this.toUpdateList[this.toUpdateList.length - 1].branch_person_in_charge_uid = this.branch.vessel_uid
          } else {
            this.toUpdateList[this.toUpdateList.length - 1].branch_person_in_charge_uid = this.branchList[this.branchList.length - 1].vessel_uid
          }
        } else {
          this.setProgressing(true)

          this.$api.branches().show(userUid)
            .then((res) => {
              this.branchList.push(res.data)
              this.addIntoUpdateList()
            })
            .catch((error) => {
              if (error.response) {
                if (error.response.status === 404) {
                  this.summary = true
                }
              }
            })
            .then(() => {
              this.setProgressing(false)
            })
        }
      },
      showSummary () {
        this.validateForm().then((result) => {
          if (result) {          
            this.checkIfBic(this.toUpdateList[this.toUpdateList.length - 1].branch_person_in_charge_uid)
          // this.summary = true
          } else {
            this.$scrollToFirstErrorInput()
          }
        })  
      },
      prepareFormData () {
        return {
          branches: this.toUpdateList.reverse(),
        }
      },
      setProgressing (value = false) {
        this.progressing = value
      },
      clearForm () {
        this.summary = false
        this.toUpdateList = [
          {
            branch_uid: this.branch.branch_uid,
            branch_person_in_charge_uid: '',
            branch_name: this.branch.branch_name,
            confirmed: false,
          },
        ]
        this.branchList = []
      },
      emitCloseDialogEvent () {
        this.$emit('close-dialog')
      },

      submitForm () {
        // let _this = this
        this.validateForm().then((result) => {
          if (result) {          
            this.setProgressing(true)
            this.$api.branches().bicTransfer(this.prepareFormData())
              .then((res) => {
                if (res.status >= 200 && res.status < 300) {
                  this.$snack({
                    message: 'BIC updated',
                  })
                }
              })
              .catch(() => {})
              .then(() => {
                this.setProgressing(false)
                this.emitCloseDialogEvent()
                this.clearForm()
              })
          } else {
            this.$scrollToFirstErrorInput()
          }
        })  
      },
      validateForm () {
        return this.$validator.validateAll()
      },
    
    },
  }
</script>

<style lang='css'>
  .overflow {
    /* overflow-y: scroll;  */
    height: 80vh;
  }
</style>

<style lang='css' scoped>  
  .autocomplete-zindex{
    z-index:250
  }
</style>
